import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SCheckbox from '../ui/SCheckbox';
import { ColorBox, CheckBox } from '../ColorBox';

const isMobile = (width) => {
  return width < 768
}


const ClearButton = ({ handleButtonClick }) => {
  return (
    <button
      className={'rit-button rit-button_theme_gray'}
      type='button'
      onClick={handleButtonClick}
    >
      Очистить
    </button>
  )
};


const Filter = ({
  onCheck,
  filterName,
  activeFabricFilters,
  filterType,
  variants,
  colorPicker,
  onFilterClear,
}) => {

  const [checkedItems, setCheckedItems] = useState(activeFabricFilters);

  const mobileMode = isMobile(window.innerWidth);
  const filtersActive = Object.keys(activeFabricFilters).length > 0;
  const getCheckedState = (filterId) => {
    return filtersActive && checkedItems.hasOwnProperty(filterId)
  };

  function handleFilterClear() {
    setCheckedItems({});
    onFilterClear();
  }

  function handleChecked(id, filterType, value) {
    if (value) {
      setCheckedItems({ ...checkedItems, [id]: value });
    } else {
      const prevItems = { ...checkedItems };
      delete prevItems[id]
      setCheckedItems(prevItems);
    }

    onCheck(id, filterType, value)
  }

  useEffect(() => {
    setCheckedItems(activeFabricFilters);
  }, [activeFabricFilters]);

  const renderCheckBoxComponent = (id, hexColor, displayName) => {

    const checked = getCheckedState(id);
    const label = `label-${id}`;
    const handleCheck = (e, value) => handleChecked(id, filterType, value);

    const colorPickerProps = {
      value: id,
      name: label,
      checked: checked,
      onCheck: handleCheck,
      isMobile: mobileMode,
      hexColor: hexColor,
    };

    const baseChecboxProps = {
      value: checked,
      id: id,
      name: label,
      checked: checked,
      onCheck: handleCheck,
      label: displayName,
    };

    const mobileChecboxProps = {
      checkboxPosition: 'right',
      color: 'gray',
      type: 'round'
    };

    if (colorPicker) {
      return (
        <ColorBox {...colorPickerProps} />
      )
    }

    if (mobileMode) {
      return (
        <SCheckbox
          {...baseChecboxProps}
          {...mobileChecboxProps}
        />
      )
    } else {
      return (
        <CheckBox {...baseChecboxProps} />
      )
    }
  }

  return (
    <div className='style-filter style-filter--no-select'>
      <div className='style-filter__header'>
        <p className='style-filter__title'>
          {filterName}
        </p>
        {filtersActive &&
          <ClearButton handleButtonClick={handleFilterClear} />
        }
      </div>
      <div className={classnames('style-filter__list', {
        'style-filter__list_type_color': colorPicker
      })}>

        {variants.map(({ id, hexColor, displayName }, i) => (
          <div
            className='style-filter__item'
            key={i}
          >
            {renderCheckBoxComponent(id, hexColor, displayName, isMobile)}
          </div>
        ))}
      </div>
    </div>
  )
}

Filter.propTypes = {
  checked: PropTypes.bool.isRequired,
  filterName: PropTypes.string.isRequired,
  filterType: PropTypes.string.isRequired,
  onCheck: PropTypes.func.isRequired,
  activeFabricFilters: PropTypes.object,
  variants: PropTypes.array.isRequired,
  colorPicker: PropTypes.bool.isRequired,
  onFilterClear: PropTypes.func.isRequired,
}

Filter.defaultProps = {
  checked: false,
  filterName: 'Фильтр',
  colorPicker: false,
  activeFabricFilters: {}
}

export default Filter;
